import chatModule from '@chat/module/store/type'
import _ from "lodash";
import { conversationsFullyScrolled, scrollToLastMessage } from '@chat/lib/helpers';

export default e => {
        console.log('[New Message emoji Listener]', e);
        let payload = e.emojiEvent;
        let conversation_key =payload.message.channel === 'user' ? payload.user_added_event : payload.message.event_id + '-' + payload.user_added_event;

        let msg_index = _.findIndex(store.state.chatModule.chat[payload.message.channel].messages[conversation_key], function (msg) {
                return msg.id === payload.message.id;
        })

        if(msg_index !== -1) {
                if (payload.event === 'add') {
                        if (store.state.chatModule.chat[payload.message.channel].messages[conversation_key][msg_index].emojies === undefined) {
                                store.state.chatModule.chat[payload.message.channel].messages[conversation_key][msg_index].emojies = [];
                        }
                        let exist_emoji_index = _.findIndex(store.state.chatModule.chat[payload.message.channel].messages[conversation_key][msg_index].emojies, function (emoji) {
                                return parseInt(emoji.user_id) === parseInt(payload.user_added_event);
                        })
                        if (exist_emoji_index !== -1) {
                                store.state.chatModule.chat[payload.message.channel].messages[conversation_key][msg_index].emojies.splice(exist_emoji_index, 1);
                        }
                        store.commit(chatModule.mutations.message.addEmoji, {
                                msg: payload.message,
                                emoji: payload.emoji.id,
                                emoji_code: payload.emoji.emoji_code,
                                msg_index: msg_index,
                                conversation_key: conversation_key,
                                user_from: payload.user_added_event
                        })
                } else {
                        store.commit(chatModule.mutations.message.deleteEmoji, {
                                msg: payload.message,
                                msg_index: msg_index,
                                conversation_key: conversation_key,
                                user_from: payload.user_added_event
                        })
                }
        }


}